<div class="cp-page" [class.cp-modal]="presentation === 'modal'">
  <p class="cp-subtitle" *ngIf="presentation === 'page'">
    Keep your account secure — choose a strong password you haven't used before.
  </p>

  <div class="cp-card">
    <form class="cp-form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
      <!-- Current Password -->
      <div class="form-group">
        <label for="currentPassword">Current Password</label>
        <div class="input-with-action">
          <input
            #currentPasswordInput
            ngbAutofocus
            id="currentPassword"
            [type]="showCurrent ? 'text' : 'password'"
            formControlName="currentPassword"
            autocomplete="current-password"
            placeholder="Enter current password"
            [class.is-invalid]="f.currentPassword.touched && f.currentPassword.invalid"
          />
          <button
            type="button"
            class="toggle-visibility"
            (click)="toggle('current')"
            [attr.aria-label]="showCurrent ? 'Hide password' : 'Show password'">
            <svg *ngIf="!showCurrent" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" fill="none" stroke="currentColor" stroke-width="2"/>
              <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-width="2"/>
            </svg>
            <svg *ngIf="showCurrent" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M3 3l18 18" stroke="currentColor" stroke-width="2" fill="none"/>
              <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" fill="none" stroke="currentColor" stroke-width="2"/>
            </svg>
          </button>
        </div>
        <div class="field-error" *ngIf="f.currentPassword.touched && f.currentPassword.invalid">
          <span *ngIf="f.currentPassword.errors?.['required']">Current password is required.</span>
          <span *ngIf="f.currentPassword.errors?.['minlength']">Must be at least 8 characters.</span>
          <span *ngIf="f.currentPassword.errors?.['maxlength']">Must be at most 80 characters.</span>
        </div>
      </div>

      <!-- New Password -->
      <div class="form-group">
        <label for="newPassword">New Password</label>
        <div class="input-with-action">
          <input
            id="newPassword"
            [type]="showNew ? 'text' : 'password'"
            formControlName="newPassword"
            autocomplete="new-password"
            placeholder="Enter new password"
            [class.is-invalid]="f.newPassword.touched && f.newPassword.invalid"
          />
          <button
            type="button"
            class="toggle-visibility"
            (click)="toggle('new')"
            [attr.aria-label]="showNew ? 'Hide password' : 'Show password'">
            <svg *ngIf="!showNew" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" fill="none" stroke="currentColor" stroke-width="2"/>
              <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-width="2"/>
            </svg>
            <svg *ngIf="showNew" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M3 3l18 18" stroke="currentColor" stroke-width="2" fill="none"/>
              <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" fill="none" stroke="currentColor" stroke-width="2"/>
            </svg>
          </button>
        </div>
        <div class="field-error" *ngIf="f.newPassword.touched && f.newPassword.invalid">
          <span *ngIf="f.newPassword.errors?.['required']">New password is required.</span>
          <span *ngIf="f.newPassword.errors?.['maxlength']">Must be at most 80 characters.</span>
        </div>
      </div>

      <!-- Confirm Password -->
      <div class="form-group">
        <label for="confirmPassword">Confirm New Password</label>
        <div class="input-with-action">
          <input
            id="confirmPassword"
            [type]="showConfirm ? 'text' : 'password'"
            formControlName="confirmPassword"
            autocomplete="new-password"
            placeholder="Confirm password"
            [class.is-invalid]="f.confirmPassword.touched && (form.errors?.['passwordMismatch'] || f.confirmPassword.invalid)"
          />
          <button
            type="button"
            class="toggle-visibility"
            (click)="toggle('confirm')"
            [attr.aria-label]="showConfirm ? 'Hide password' : 'Show password'">
            <svg *ngIf="!showConfirm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" fill="none" stroke="currentColor" stroke-width="2"/>
              <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-width="2"/>
            </svg>
            <svg *ngIf="showConfirm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M3 3l18 18" stroke="currentColor" stroke-width="2" fill="none"/>
              <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" fill="none" stroke="currentColor" stroke-width="2"/>
            </svg>
          </button>
        </div>
        <div class="field-error"
             *ngIf="(f.confirmPassword.touched || f.newPassword.touched) && (form.errors?.['passwordMismatch'] || f.confirmPassword.invalid)">
          <span *ngIf="form.errors?.['passwordMismatch']">Passwords do not match.</span>
          <span *ngIf="f.confirmPassword.errors?.['required']">Confirm password is required.</span>
        </div>
      </div>

      <div class="form-actions">
        <button type="button" class="btn-secondary" (click)="cancel()" [disabled]="loading">Cancel</button>
        <button type="submit" class="btn-primary" [disabled]="form.invalid || loading">
          <span *ngIf="!loading">Change Password</span>
          <span *ngIf="loading">Changing…</span>
        </button>
      </div>
    </form>

    <!-- Requisitos en vivo: refleja los validadores reales del formulario -->
    <aside class="cp-aside">
      <div class="cp-aside-header">
        <span class="cp-shield" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          </svg>
        </span>
        <h2>Password requirements</h2>
      </div>
      <ul class="cp-checklist" aria-live="polite">
        <li *ngFor="let req of requirements" [class.ok]="req.ok">
          <span class="cp-check" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 6L9 17l-5-5"/>
            </svg>
          </span>
          <span class="cp-req-label">{{ req.label }}</span>
        </li>
      </ul>
      <p class="cp-aside-note">
        You'll be asked to sign in again on other devices after changing your password.
      </p>
    </aside>
  </div>
</div>
